/**
 * Paginación FE de líneas dentro de un remito (no del listado de remitos).
 * Default 10; opciones 10 / 25. Combo: paginar filas visuales ya agrupadas.
 */

export const REMITO_ITEM_PAGE_SIZE_OPTIONS = [10, 25] as const;
export const REMITO_ITEM_PAGE_SIZE_DEFAULT = 10;

export function remitoItemPageSlice<T>(
  items: readonly T[],
  page: number,
  pageSize: number = REMITO_ITEM_PAGE_SIZE_DEFAULT,
): { rows: T[]; page: number; pageSize: number; total: number } {
  const total = items.length;
  const size = pageSize > 0 ? pageSize : REMITO_ITEM_PAGE_SIZE_DEFAULT;
  const maxPage = Math.max(1, Math.ceil(total / size) || 1);
  const safePage = Math.min(Math.max(1, Number(page) || 1), maxPage);
  const start = (safePage - 1) * size;
  return {
    rows: items.slice(start, start + size) as T[],
    page: safePage,
    pageSize: size,
    total,
  };
}
